<template>
	<div class="appSettingsSyncRoot" role="dialog" aria-labelledby="appSettingsSyncTitle">
		<div class="titleBar">
			<div id="appSettingsSyncTitle" class="title" role="alert">AppSettings Sync: {{release.Name}} @ {{environment.Name}}</div>
		</div>
		<div class="dialogBody">
			<template v-if="release.AppSettingsDiffs.length">
				<div v-for="(appSettingsDiff, index) in release.AppSettingsDiffs" :key="index" class="diffSection">
					<p>Diff between "{{appSettingsDiff.FirstAgentName}}" and "{{appSettingsDiff.SecondAgentName}}":</p>
					<div class="htmlDiff" v-html="appSettingsDiff.HtmlDiff"></div>
				</div>
				<p>Select an Agent to apply their AppSettings to all:</p>
				<div v-for="(agent, index) in agentAppSettingsList" :key="agent.name" class="agentSelectContainer">
					<slide-button :key="'slideBtn_appSettingsSync_' + index + '_' + slideBtnCounter"
								  :auto-width="false"
								  :circle="true"
								  :disabled="false"
								  :noanimate="true"
								  :width="300"
								  :height="60"
								  :text="agent.name"
								  success-text="selecting"
								  @completed="onSelectCommanded(agent.appSettings)"
								  :requireReleaseToComplete="true" />
				</div>
			</template>
			<p v-else>This release's AppSettings are in sync.</p>
		</div>
		<div class="buttons">
			<div ref="closeBtn" class="dialogButton" tabindex="0" @click="DefaultClose" @keydown.space.enter.prevent="DefaultClose">
				Close
			</div>
		</div>
	</div>
</template>

<script>
	import SlideButton from 'appRoot/vues/common/controls/SlideButton.vue';
	import { ChangeReleaseAppSettings } from 'appRoot/api/ReleaseData';
	import { ProgressDialog } from 'appRoot/scripts/ModalDialog';

	export default {
		components: { SlideButton },
		props:
		{
			environment: {
				type: Object,
				required: true
			},
			release: {
				type: Object,
				required: true
			}
		},
		data()
		{
			return {
				savingAppSettings: false,
				slideBtnCounter: 0,
			};
		},
		created()
		{
		},
		beforeUnmount()
		{
		},
		computed:
		{
			isBusy()
			{
				return this.savingAppSettings;
			},
			agentAppSettingsList()
			{
				let arr = [];
				let addedAgents = {};
				for (let i = 0; i < this.release.AppSettingsDiffs.length; i++)
				{
					let d = this.release.AppSettingsDiffs[i];
					if (!addedAgents[d.FirstAgentName])
					{
						addedAgents[d.FirstAgentName] = true;
						arr.push({ name: d.FirstAgentName, appSettings: d.FirstAgentAppSettings });
					}
					if (!addedAgents[d.SecondAgentName])
					{
						addedAgents[d.SecondAgentName] = true;
						arr.push({ name: d.SecondAgentName, appSettings: d.SecondAgentAppSettings });
					}
				}
				return arr;
			}
		},
		methods:
		{
			SetFocus()
			{
				if (this.$refs.closeBtn)
					this.$refs.closeBtn.focus();
			},
			DefaultClose()
			{
				if (this.isBusy)
					toaster.Warning("This release is undergoing a background operation. Closing the dialog is not currently allowed.");
				else
					this.$emit("close");
			},
			onSelectCommanded(appSettings)
			{
				this.savingAppSettings = true;
				let modalProgress = ProgressDialog("Syncing AppSettings");
				ChangeReleaseAppSettings(this.environment.Name, this.release.Name, appSettings, true)
					.then(result =>
					{
						modalProgress.close();
						if (result.error)
						{
							this.savingAppSettings = false;
							toaster.Error(result.error);
						}
						else
							location.reload();
					})
					.catch(err =>
					{
						modalProgress.close();
						this.savingAppSettings = false;
						toaster.Error(err);
					})
					.finally(() =>
					{
						this.slideBtnCounter++;
					});
			},
		},
		watch:
		{
		}
	}
</script>

<style scoped>
	.appSettingsSyncRoot
	{
		width: calc(100vw - 30px);
		max-height: calc(100vh - 30px);
		background-color: #FFFFFF;
	}

	.titleBar
	{
		background-color: #FFFFFF;
		padding: 8px 14px;
		box-sizing: border-box;
	}

	.title
	{
		text-align: center;
		color: black;
		font-weight: bold;
		font-size: 16pt;
	}

	.dialogBody
	{
		padding: 4px 12px 0px 12px;
	}

	.buttons
	{
		display: flex;
	}

	.dialogButton
	{
		display: inline-block;
		cursor: pointer;
		color: #1e78af;
		font-weight: bold;
		font-size: 16pt;
		box-sizing: border-box;
		position: relative;
		padding: 9px 5px 8px 5px;
		flex: 1 0 auto;
		text-align: center;
	}

		.dialogButton:hover
		{
			background-color: rgba(0,0,0,0.05);
		}

	.diffSection
	{
		margin-bottom: 1em;
	}

	.agentSelectContainer
	{
		margin-bottom: 1em;
	}

	@media (min-width: 600px)
	{
		.appSettingsSyncRoot
		{
			width: 90vw;
		}
	}
</style>